// src/components/DistrictBadge.jsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Chip = styled(Link)`
  display:inline-flex; align-items:center; gap:6px;
  border:1px solid var(--bdr); background:var(--card); border-radius:999px;
  padding:6px 10px; font-size:12px; line-height:1; white-space:nowrap; text-decoration:none; color:inherit;
  box-shadow:var(--shadow);
`;

export default function DistrictBadge({ slug, name, className, onClick }){
  if (!slug || !name) return null;
  return (
    <Chip to={`/districts/${encodeURIComponent(slug)}`} className={className} onClick={onClick}>
      {String(name)}
    </Chip>
  );
}
